import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Tab, Tabs } from '@material-ui/core';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { RESOURCE_MANAGEMENT_TAB_ENUM } from '../../enums';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: -1
  }
}));

const getFormattedMessages = formatMessage => ({
  resourceManagementTabAriaLabel: formatMessage({
    id: 'resourceManagementTabs.ariaLabel'
  }),
  overview: formatMessage({
    id: 'resourceManagementTabs.overview'
  }),
  timeline: formatMessage({
    id: 'resourceManagementTabs.timeline'
  }),
  list: formatMessage({
    id: 'resourceManagementTabs.list'
  })
});

export const ResourceManagementTabs = ({ selectedTab, onChange }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const isMobile = useIsBreakpointDown('sm');
  const labels = getFormattedMessages(formatMessage);

  return (
    <Tabs
      classes={classes}
      indicatorColor="primary"
      value={selectedTab}
      onChange={onChange}
      aria-label={labels.resourceManagementTabAriaLabel}
    >
      <Tab
        value={RESOURCE_MANAGEMENT_TAB_ENUM.OVERVIEW}
        label={labels.overview}
      />
      {!isMobile && (
        <Tab
          value={RESOURCE_MANAGEMENT_TAB_ENUM.TIMELINE}
          label={labels.timeline}
        />
      )}
      <Tab value={RESOURCE_MANAGEMENT_TAB_ENUM.LIST} label={labels.list} />
    </Tabs>
  );
};

ResourceManagementTabs.propTypes = {
  selectedTab: PropTypes.oneOf([
    RESOURCE_MANAGEMENT_TAB_ENUM.TIMELINE,
    RESOURCE_MANAGEMENT_TAB_ENUM.LIST,
    RESOURCE_MANAGEMENT_TAB_ENUM.OVERVIEW
  ]),
  onChange: PropTypes.func.isRequired
};

export default ResourceManagementTabs;
